import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./RegisterUserBlock').then(m => ({default: m.RegisterUserBlock})),
)

export const registerUserBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
